<template>
	<div>
		<div class="content mt-5" id="default-slot">
			<p>To customize the content of any column, simply use its <code>default</code> scoped slot to which the following fields will be passed:</p>
			<ui-table :items="defaultSlotProps" bordered striped table-class="docs" container-class="mb-3" hide-headers>
				<ui-table-column prop="prop" cell-tag="th" fit/>
				<ui-table-column prop="description"/>
			</ui-table>
			<pre v-highlightjs class="box pa-0"><code class="html" v-pre>&lt;ui-table :items=&quot;items&quot;&gt;
	&lt;ui-table-column prop=&quot;id&quot; #default=&quot;{ item }&quot;&gt;
		&lt;b&gt;#{{item.id}}&lt;/b&gt;
	&lt;/ui-table-column&gt;
	&lt;ui-table-column header=&quot;key&quot; #default=&quot;{ itemKey }&quot;&gt;
		Row key is: &lt;b&gt;{{itemKey}}&lt;/b&gt;
	&lt;/ui-table-column&gt;
	&lt;ui-table-column prop=&quot;body&quot; #default=&quot;{ value }&quot;&gt;
		Body length: &lt;b&gt;{{value.length}}&lt;/b&gt;
	&lt;/ui-table-column&gt;
&lt;/ui-table&gt;</code></pre>
		</div>
		<ui-table :items="items" container-class="box">
			<ui-table-column prop="id" #default="{ item }">
				<b>#{{item.id}}</b>
			</ui-table-column>
			<ui-table-column header="key" #default="{ itemKey }">
				Row key is: <b>{{itemKey}}</b>
			</ui-table-column>
			<ui-table-column prop="body" #default="{ value }">
				Body length: <b>{{value.length}}</b>
			</ui-table-column>
		</ui-table>
	</div>
</template>

<script>

    export default {
        name: "default-slot",
		props: {
            items: Array
		},
		data() {
            return {
                defaultSlotProps: [
                    { prop: "item", description: "the element that is processed by the row" },
                    { prop: "itemKey", description: "the key of that element" },
                    { prop: "value", description: "the value obtained, if possible, through the prop attribute" },
                ]
			}
		}
    }
</script>